import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return (
      <div style={styles.splash}>
        <div style={styles.spinner} />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

const styles = {
  splash: {
    minHeight: "100vh",
    background: "var(--khv-bg)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 32,
    height: 32,
    border: "3px solid var(--khv-border-strong)",
    borderTopColor: "var(--khv-accent)",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  },
};
